import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import DataTable from 'react-data-table-component';
import { FaUserFriends } from 'react-icons/fa';
import { MdDelete, MdEdit, MdHomeFilled } from 'react-icons/md';
import styles from "./dashboard.module.css";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, BarElement, CategoryScale, LinearScale, PointElement, LineElement, RadarController, RadialLinearScale } from "chart.js";
import { Pie, Bar, Line, Scatter, Radar } from "react-chartjs-2";
import WindowLayout from '../utils/layout/windowsLayout';
ChartJS.register(ArcElement, Tooltip, Legend, BarElement, CategoryScale, LinearScale, PointElement, LineElement, RadarController, RadialLinearScale);



export default function Dashboard(props) {

    const { windowSize } = useAuth();

    const [showModal, setShowModal] = useState(false);

    useEffect(() => {


    }, [])
    const pieData = {
        labels: ["Group1", "Group2"],
        datasets: [
            {
                label: "Graph1",
                data: [60, 40],
                backgroundColor: ["#FF6384", "#36A2EB"],
                hoverBackgroundColor: ["#FF6384", "#36A2EB"],
            },
        ],
    };

    const barData = {
        labels: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio"],
        datasets: [
            {
                label: "Graph2",
                data: [50, 70, 60, 80, 90, 100],
                backgroundColor: "#4BC0C0",
            },
        ],
    };

    const lineData = {
        labels: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio"],
        datasets: [
            {
                label: "Graph3",
                data: [70, 75, 80, 85, 90, 95],
                borderColor: "#FFCD56",
                backgroundColor: "#FFCD56",
                fill: false,
            },
        ],
    };

    const horizontalBarData = {
        labels: ["Grupo A", "Grupo B", "Grupo C", "Grupo D"],
        datasets: [
            {
                label: "Graph4",
                data: [30, 45, 60, 75],
                backgroundColor: ["#FF6384", "#36A2EB", "#FFCD56", "#4BC0C0"],
            },
        ],
    };

    const radarData = {
        labels: ["Group1", "Group2", "Group3", "Group4", "Group5"],
        datasets: [
            {
                label: "Graph5",
                data: [80, 70, 60, 90, 85],
                backgroundColor: "rgba(75, 192, 192, 0.2)",
                borderColor: "#4BC0C0",
                borderWidth: 1,
            },
        ],
    };

    const scatterData = {
        datasets: [
            {
                label: "Graph6",
                data: [
                    { x: 1, y: 50 },
                    { x: 2, y: 60 },
                    { x: 3, y: 70 },
                    { x: 4, y: 80 },
                    { x: 5, y: 90 },
                ],
                backgroundColor: "#FF6384",
            },
        ],
    };
    return (
        <>
            <WindowLayout
                title="DASHBOARD"
                route={["Dashboard"]}
                icon={<MdHomeFilled />}
            >
                <div className='paperContainer'>
                    <div style={{ fontSize: "18px" }}>Selecciona un modulo del menu desplegable para empezar</div>
                    <hr></hr>
                    <div className={styles.containerGraph}>
                        <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
                            <div style={{ display: "flex", flexDirection: "column", gap: "20px",flexWrap:"wrap" }}>
                                {/* Primera fila */}
                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                    {/* Gráfica de pastel */}
                                    <div style={{ flex: 1, margin: "0 10px", padding: "10px", border: "1px solid #ddd", borderRadius: "8px" }}>
                                        <h3 style={{ textAlign: "center" }}>Graph1</h3>
                                        <Pie data={pieData} />
                                    </div>

                                    {/* Gráfica de barras */}
                                    <div style={{ flex: 1, margin: "0 10px", padding: "10px", border: "1px solid #ddd", borderRadius: "8px" }}>
                                        <h3 style={{ textAlign: "center" }}>Graph2</h3>
                                        <Bar data={barData} />
                                    </div>

                                    {/* Gráfica de onda (línea) */}
                                    <div style={{ flex: 1, margin: "0 10px", padding: "10px", border: "1px solid #ddd", borderRadius: "8px" }}>
                                        <h3 style={{ textAlign: "center" }}>Graph3</h3>
                                        <Line data={lineData} />
                                    </div>
                                </div>

                                {/* Segunda fila */}
                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                    {/* Gráfica de barras horizontal */}
                                    <div style={{ flex: 1, margin: "0 10px", padding: "10px", border: "1px solid #ddd", borderRadius: "8px" }}>
                                        <h3 style={{ textAlign: "center" }}>Graph4</h3>
                                        <Bar data={horizontalBarData} options={{ indexAxis: "y" }} />
                                    </div>

                                    {/* Gráfica de radar */}
                                    <div style={{ flex: 1, margin: "0 10px", padding: "10px", border: "1px solid #ddd", borderRadius: "8px" }}>
                                        <h3 style={{ textAlign: "center" }}>Graph5</h3>
                                        <Radar data={radarData} />
                                    </div>

                                    {/* Gráfica de dispersión */}
                                    <div style={{ flex: 1, margin: "0 10px", padding: "10px", border: "1px solid #ddd", borderRadius: "8px" }}>
                                        <h3 style={{ textAlign: "center" }}>Graph6</h3>
                                        <Scatter data={scatterData} options={{ scales: { x: { beginAtZero: true }, y: { beginAtZero: true } } }} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </WindowLayout>
            
        </>
    );
} 